import { IActivityTrackingContract, IActivityTrackingSet } from "@ms-ofb/floodgate-shared-typings";

export class ActivityTrackingContract implements IActivityTrackingContract {
	public surveyId: string;
	public trackingSet: IActivityTrackingSet;

	public constructor(surveyId: string, trackingSet: IActivityTrackingSet) {
		this.surveyId = surveyId;
		this.trackingSet = trackingSet;
	}
}
